import { collection } from 'infra/collection'
import { Observable } from 'rxjs'

import User from 'iam/models/User'
import { PayoutMethodAPI } from './API'
import { BillingProfileAPI } from 'billing/API'
import { PayoutMethodResource } from './dtos/payout-method'
import { PayoutMethod } from './PayoutMethod'
import { Id } from 'types/definitions'

/**
 * Manage payout methods.
 */
export default class PayoutMethodStore {
  payoutMethods = collection<PayoutMethodResource, PayoutMethod>({
    create: () => new PayoutMethod(),
  })

  /**
   * Constructor.
   */
  constructor(
    private billingProfileApi: BillingProfileAPI,
    currentUser$: Observable<User>,
    private payoutMethodApi?: PayoutMethodAPI,
    public isPayoutsEnabled: boolean = false
  ) {
    currentUser$.subscribe(() => {
      this.payoutMethods.clear()
    })
  }

  /**
   * Fetches payout method for a user using BigMoney API.
   */
  async fetchPayoutMethod(userPublicId: Id) {
    return this.payoutMethodApi
      ? this.payoutMethodApi
          .getByUserPublicId(Id.assert(userPublicId))
          .then(this.payoutMethods.set)
          .catch((err) => {
            if (err.response?.status === 404 || err.statusCode === 404) {
              return null
            }

            throw err
          })
      : null
  }

  async connectStripe(userPublicId: Id, code: string) {
    return this.payoutMethodApi
      ? this.payoutMethodApi.connectStripe(Id.assert(userPublicId), code)
      : null
  }
}
